import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getOverallQuestion } from 'global/js/helpers';
import * as Actions from 'containers/Home/actions';
import * as experienceActions from './actions';
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import StarRadioButtonList from 'components/StarRadioButtonList/StarRadioButtonList';
import TextArea from 'components/TextArea/TextArea';
import './TourExperience.scss';

class OverallExperience extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * Checks if there are multiple TD questions, and returns a link to the
     * first question that includes the total number of TD quesitons.
     */
    checkTdQuestions = () => {
        let numTdQuestions = 0;

        // Loop over the overall questions and increment each time we see a TD one.
        for (const question of this.props.surveyData.OverallSubmission.OverallQuestions)
            if (question.Type.toLowerCase().includes('tourdirector'))
                numTdQuestions++;

        return numTdQuestions > 0 ? `/TD/1/${numTdQuestions}` : '/TC';
    }

	/**
	 * Called when there is a change to the text area value. Handles updating
	 * the text value state.
	 *
	 * @param comment : {String}
	 */
    handleChange = (comment) => {
        this.props.experienceActions.setOverallAnswer({
            type: 'TourExperience',
            comment: comment
        });
    }

    render() {
        const surveyData = this.props.surveyData;
        const question = getOverallQuestion(surveyData.OverallSubmission.OverallQuestions, 'TourExperience');
        const questionAnswer = question.Answer.AnswerRating;
        const questionComment = question.Answer.AnswerComment;
        const questionText = question.Text;
        const questionType = question.Type;
        const subText = question.SubText;

        return (
            <section className='wrapper tour-experience'>
                {surveyData.IsBackup && (
                    <Header customerData={surveyData.Evaluator} isOverall={true} />
                )}

                <div className='container'>
                    <h1 className="stay-name">Overall <br /> Experience</h1>
                    
                    <div className='content'>
                        <Question questionText={questionText} />
						
                        <StarRadioButtonList
                            answerValue={questionAnswer}
                            handleClick={this.props.experienceActions.setOverallAnswer}
                            questionType={questionType}
                        />

                        <Question questionText={subText} />

                        <TextArea
                            handleChange={this.handleChange}
                            textValue={questionComment}
                        />
        				
                        <Navigation
                            actions={this.props.actions}
                            answerValue={questionAnswer}
                            individualID={this.props.individualID}
                            isOverall={true}
                            locationIndex={1}
                            nextLink={this.checkTdQuestions()} 
                            prevLink='/NPS' 
                            prodTourID={this.props.prodTourID}
                            surveyData={this.props.surveyData}
                        />
                    </div>
                </div>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        individualID: state.dataReducer.individualID,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        experienceActions: bindActionCreators(experienceActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OverallExperience));



// WEBPACK FOOTER //
// ./application/containers/TourExperience/TourExperience.jsx